import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { storableError } from '../../util/errors';
import { getAllTransitionsForEveryProcess } from '../../transactions/transaction';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';

const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.createdAt : null;
    })
  );

// ================ Action types ================ //
export const FETCH_SALES_REQUEST = 'app/SalesPage/FETCH_SALES_REQUEST';
export const FETCH_SALES_SUCCESS = 'app/SalesPage/FETCH_SALES_SUCCESS';
export const FETCH_SALES_ERROR = 'app/SalesPage/FETCH_SALES_ERROR';

// ================ Reducer ================ //
const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const initialState = {
  fetchInProgress: false,
  fetchSalesError: null,
  pagination: null,
  transactionRefs: [],
};

export default function salesPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SALES_REQUEST:
      return { ...state, fetchInProgress: true, fetchSalesError: null };
    case FETCH_SALES_SUCCESS: {
      const transactions = sortedTransactions(payload.data.data);
      return {
        ...state,
        fetchInProgress: false,
        transactionRefs: entityRefs(transactions),
        pagination: payload.data.meta,
      };
    }
    case FETCH_SALES_ERROR:
      return { ...state, fetchInProgress: false, fetchSalesError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //
const fetchSalesRequest = () => ({ type: FETCH_SALES_REQUEST });
const fetchSalesSuccess = response => ({
  type: FETCH_SALES_SUCCESS,
  payload: response,
});
const fetchSalesError = e => ({
  type: FETCH_SALES_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //
const SALES_PAGE_SIZE = 50;

// statusFilters: array of transition strings, createdAtStart/End: ISO strings
export const loadData = ({ statusFilters, createdAtStart, createdAtEnd } = {}) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(fetchSalesRequest());

  const apiQueryParams = {
    only: 'sale',
    lastTransitions: statusFilters && statusFilters.length > 0 ? statusFilters : undefined,
    include: [
      'listing',
      'listing.images',
      'provider',
      'provider.profileImage',
      'customer',
      'customer.profileImage',
      'booking',
    ],
    'fields.transaction': [
      'processName',
      'lastTransition',
      'lastTransitionedAt',
      'createdAt',
      'transitions',
      'payinTotal',
      'payoutTotal',
      'lineItems',
      'protectedData',
    ],
    'fields.listing': ['title', 'availabilityPlan', 'publicData.listingType'],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'deleted', 'banned'],
    'fields.image': [
      'variants.square-small',
      'variants.square-small2x',
      'variants.listing-card',
      'variants.listing-card-2x',
    ],
    page: 1,
    perPage: SALES_PAGE_SIZE,
  };

  if (createdAtStart) apiQueryParams.createdAtStart = new Date(createdAtStart).toISOString();
  if (createdAtEnd) {
    const endIso = new Date(createdAtEnd);
    endIso.setHours(23, 59, 59, 999);
    apiQueryParams.createdAtEnd = endIso.toISOString();
  }

  return sdk.transactions
    .query(apiQueryParams)
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchSalesSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchSalesError(storableError(e)));
      throw e;
    });
};


